import { render, staticRenderFns } from "./UsersGroups.vue?vue&type=template&id=f4221bb2&scoped=true&"
import script from "./UsersGroups.vue?vue&type=script&lang=js&"
export * from "./UsersGroups.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroups.vue?vue&type=style&index=0&id=f4221bb2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4221bb2",
  null
  
)

component.options.__file = "UsersGroups.vue"
export default component.exports